import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './north-dakota.model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-north-dakota',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './north-dakota.component.html',
})
export class NorthDakotaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('north-dakota', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('north-dakota', null);
    }
  }

  dynamicLimitId: Object = {
    CombinedSingleMinLimit_DropDown: 'combinedsingleminlimit_50k',
    SplitMinLimits_DropDown: 'splitminlimits_25k_50k',
    UMPDMinLimit_DropDown: 'umpdminlimit_50k',
  };
}
